// src/hooks/useTheme.js
// Tema global de Bellason. Default light. Cambia el atributo data-theme en
// <html>, lo cual cambia las CSS variables definidas en index.css.
//
// Persiste en localStorage para que la próxima visita respete la preferencia
// del usuario.
import { useEffect, useState } from 'react'

const STORAGE_KEY = 'bellason_theme'
const DEFAULT_THEME = 'light'

function readInitial() {
  if (typeof window === 'undefined') return DEFAULT_THEME
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    if (v === 'light' || v === 'dark') return v
  } catch { /* ok */ }
  return DEFAULT_THEME
}

export function useTheme() {
  const [theme, setThemeState] = useState(readInitial)

  // Aplica el tema al <html> apenas cambia
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme)
  }, [theme])

  function setTheme(next) {
    const value = next === 'dark' ? 'dark' : 'light'
    try { localStorage.setItem(STORAGE_KEY, value) } catch { /* ok */ }
    setThemeState(value)
  }

  function toggleTheme() {
    setTheme(theme === 'dark' ? 'light' : 'dark')
  }

  return { theme, setTheme, toggleTheme }
}

// Helper para componentes que solo necesitan el toggle sin re-render
export function applyInitialTheme() {
  if (typeof document === 'undefined') return
  document.documentElement.setAttribute('data-theme', readInitial())
}
